import {SignalType} from 'gabi-api-ts/v2/common/signals/signals';

export type SignalColorsDefinition = {
    dark: string;
    normal: string;
    light: string;
    clear: string;
};

export type SignalDomainDefinition = {
    domain: [number, number];
    ticks: number[];
};
export type SignalDomainDefinitions = {
    normal: SignalDomainDefinition;
    extended?: SignalDomainDefinition;
};

export type SignalDefinition = {
    unit: string;
    chartDomain: SignalDomainDefinitions;
    colors: SignalColorsDefinition;
};

const defaultDefinition: SignalDefinition = { // Default or unknown value
    unit: '',
    chartDomain: {
        normal: {
            domain: [
                40,
                240,
            ],
            ticks: [ 40, 80, 120, 160, 200, 240 ],
        }
    },
    colors: {
        dark: '#BDBDBD',
        normal: '#BDBDBD',
        light: '#cccccc',
        clear: '#dafadc',
    },
};

export const SignalDefinitions: Record<SignalType | '-1', SignalDefinition> = {
    [-1]: defaultDefinition,
    [SignalType.NEWS2]: {
        unit: '',
        chartDomain: {
            normal: {
                domain: [
                    0.0,
                    6.0,
                ],
                ticks: [ 0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0 ],
            }
        },
        colors: {
            dark: '#E9D856',
            normal: '#E9D856',
            light: '#E9D856',
            clear: '#fcf5b7',
        },
    },
    [SignalType.Signal_Actigraphy]: {
        unit: 'G',
        chartDomain: {
            normal: {
                domain: [
                    0.0,
                    0.5,
                ],
                ticks: [ 0.0, 0.25, 0.5 ],
            }
        },
        colors: {
            dark: '#E9D856',
            normal: '#E9D856',
            light: '#E9D856',
            clear: '#fcf5b7',
        },
    },
    [SignalType.Signal_BP_SYS]: { // FIXME Swapped
        unit: 'mmHg',
        chartDomain: {
            normal: {
                domain: [
                    40,
                    140,
                ],
                ticks: [ 40, 60, 80, 100, 120, 140 ],
            },
            extended: {
                domain: [
                    20,
                    180,
                ],
                ticks: [ 20, 40, 60, 80, 100, 120, 140, 160, 180 ],
            }
        },
        colors: {
            dark: '#e99d56',
            normal: '#e6b78c',
            light: '#eecbaa',
            clear: '#f7e7d6',
        },
    },
    [SignalType.Signal_BP_DIA]: { // FIXME Swapped
        unit: 'mmHg',
        chartDomain: {
            normal: {
                domain: [
                    40,
                    140,
                ],
                ticks: [ 40, 60, 80, 100, 120, 140 ],
            },
            extended: {
                domain: [
                    20,
                    180,
                ],
                ticks: [ 20, 40, 60, 80, 100, 120, 140, 160, 180 ],
            }
        },
        colors: {
            dark: '#e99d56',
            normal: '#e6b78c',
            light: '#eecbaa',
            clear: '#f7e7d6',
        },
    },
    [SignalType.Signal_PR]: {
        unit: 'bpm',
        chartDomain: {
            normal: {
                domain: [
                    40,
                    200,
                ],
                ticks: [ 40, 80, 120, 160, 200 ],
            },
            extended: {
                domain: [
                    40,
                    240,
                ],
                ticks: [ 40, 80, 120, 160, 200, 240 ],
            }
        },
        colors: {
            dark: '#65D376',
            normal: '#65D376',
            light: '#a5ecb0',
            clear: '#dafadc',
        },
    },
    [SignalType.Signal_RR]: {
        unit: 'rpm',
        chartDomain: {
            normal: {
                domain: [
                    10,
                    40,
                ],
                ticks: [ 10, 20, 30, 40 ],
            },
            extended: {
                domain: [
                    0,
                    100,
                ],
                ticks: [ 0, 20, 40, 60, 80, 100 ],
            }
        },
        colors: {
            dark: '#b276f8',
            normal: '#b276f8',
            light: '#D9C4F8',
            clear: '#ede1ff',
        },
    },
    [SignalType.Signal_SPO2]: {
        unit: '%',
        chartDomain: {
            normal: {
                domain: [
                    70,
                    100,
                ],
                ticks: [ 70, 80, 90, 100 ],
            },
            extended: {
                domain: [
                    50,
                    100,
                ],
                ticks: [ 50, 60, 70, 80, 90, 100 ],
            }
        },
        colors: {
            dark: '#5799F2',
            normal: '#5799F2',
            light: '#A9CCF9',
            clear: '#deedff',
        },
    },
};
